import React from 'react';
import { useTranslation } from 'react-i18next';
import IconParagraph from './IconParagraph';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/navigation';
import { useAuth } from 'src/features/authorization';
import { Heading } from '@innovationnorway/cl-react';
import useSivaYearList from 'src/hooks/use-year-list-reporting';

const SivaReporting = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');
  const { checkAccess } = useAuth();
  const { read: isBusinessGarden } = checkAccess('UI_SivaBusinessGarden');
  const [latestReportingYear] = useSivaYearList(2023);

  return (
    <div className="stack">
      <Heading level={2} className="margin-bottom--3">
        {tHelpAndSupport('commonQuestions.SivaReporting.Header')}
      </Heading>
      <p>{tHelpAndSupport('commonQuestions.SivaReporting.Ingress')}</p>
      <IconParagraph
        iconDef={{ prefix: 'fal', iconName: 'traffic-light' }}
        header={tHelpAndSupport('commonQuestions.SivaReporting.Status.Header')}
      >
        <p>{tHelpAndSupport('commonQuestions.SivaReporting.Status.Text')}</p>
      </IconParagraph>
      <Link to={`${ROUTES.SIVA.IDEAS_AND_COMPANIES.BASE}`} className="display--block">
        {tHelpAndSupport('commonQuestions.IdeasAndCompanies.LinkCompany')}
      </Link>
      <IconParagraph
        faIcon={'fa-light fa-list-ul'}
        header={tHelpAndSupport('commonQuestions.SivaReporting.SelfDeclaration.Header')}
      >
        <p>{tHelpAndSupport('commonQuestions.SivaReporting.SelfDeclaration.Text')}</p>
      </IconParagraph>
      <Link to={`${ROUTES.SIVA.REPORTING.DECLARATION.BASE}`} className="display--block">
        {tHelpAndSupport('commonQuestions.SivaReporting.SelfDeclaration.Link')}
      </Link>
      <IconParagraph
        faIcon={'fa-light fa-check-circle'}
        header={tHelpAndSupport('commonQuestions.SivaReporting.Yearly.Header')}
      >
        <p>{tHelpAndSupport('commonQuestions.SivaReporting.Yearly.Text')}</p>
      </IconParagraph>
      {!isBusinessGarden && (
        <IconParagraph
          faIcon={'fa-light fa-file-signature'}
          header={tHelpAndSupport('commonQuestions.SivaReporting.Contract.Header')}
        >
          <p>{tHelpAndSupport('commonQuestions.SivaReporting.Contract.Text')}</p>
        </IconParagraph>
      )}

      <IconParagraph
        faIcon={'fa-light fa-file-spreadsheet'}
        header={tHelpAndSupport('commonQuestions.SivaReporting.Esa.Header')}
      >
        <p>{tHelpAndSupport('commonQuestions.SivaReporting.Esa.Text')}</p>
      </IconParagraph>
      <Link className="display--block" to={ROUTES.SIVA.REPORTING.FUNDS.YEAR(latestReportingYear).ESA}>
        {tHelpAndSupport('commonQuestions.IdeasAndCompanies.Esa.Link')}
      </Link>
      <IconParagraph
        iconDef={{ prefix: 'fal', iconName: 'chart-bar' }}
        header={tHelpAndSupport('commonQuestions.SivaReporting.GoalAchievement.Header')}
      >
        <p>{tHelpAndSupport('commonQuestions.SivaReporting.GoalAchievement.Text')}</p>
      </IconParagraph>
      <Link className="display--block" to={ROUTES.SIVA.REPORTING.ACHIEVED.BASE}>
        {tHelpAndSupport('commonQuestions.SivaReporting.GoalAchievement.Link')}
      </Link>
    </div>
  );
};

export default SivaReporting;
